import { createFileRoute, Navigate, Link } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-session";
import { PageLoader } from "@/components/PageLoader";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/admin/ops/api-docs")({
  head: () => ({
    meta: [{ title: "API Docs — Structura Market" }],
    links: [
      { rel: "stylesheet", href: "https://unpkg.com/swagger-ui-dist@5.17.14/swagger-ui.css" },
    ],
  }),
  component: ApiDocsPage,
});

declare global {
  interface Window {
    SwaggerUIBundle: (opts: Record<string, unknown>) => void;
  }
}

function ApiDocsPage() {
  const { user, isLoading } = useSession();

  useEffect(() => {
    if (!user) return;
    const existing = document.getElementById("swagger-ui-bundle-script");
    if (existing) {
      initSwagger();
      return;
    }
    const script = document.createElement("script");
    script.id = "swagger-ui-bundle-script";
    script.src = "https://unpkg.com/swagger-ui-dist@5.17.14/swagger-ui-bundle.js";
    script.onload = initSwagger;
    document.head.appendChild(script);
  }, [user]);

  function initSwagger() {
    if (typeof window.SwaggerUIBundle !== "function") return;
    window.SwaggerUIBundle({
      url: "/api/v1/openapi",
      dom_id: "#swagger-ui-root",
      presets: [
        (window as unknown as { SwaggerUIBundle: { presets: { apis: unknown; SwaggerUIStandalonePreset: unknown } } }).SwaggerUIBundle.presets.apis,
      ],
      layout: "BaseLayout",
      deepLinking: true,
      tryItOutEnabled: true,
      persistAuthorization: true,
    });
  }

  if (isLoading) return <PageLoader variant="screen" label="Verificando acceso…" />;
  if (!user || (user.role !== "super_admin" && user.role !== "viewer")) {
    return <Navigate to="/acceso/comercio" search={{ returnTo: "/admin/ops/api-docs" }} replace />;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex items-center gap-3 border-b border-border px-6 py-3 bg-card shrink-0">
        <div>
          <Link
            to="/admin"
            search={{ tab: "operaciones" } as never}
            className="mb-1 inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Operaciones
          </Link>
          <h1 className="text-sm font-semibold text-foreground">API Pública — Structura Market</h1>
          <p className="text-xs text-muted-foreground">
            Spec JSON:{" "}
            <a
              href="/api/v1/openapi"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary underline-offset-2 hover:underline"
            >
              /api/v1/openapi
            </a>
          </p>
        </div>
      </div>
      {/* color-scheme: light fuerza que Swagger UI use sus estilos claros sin importar el tema del shell */}
      <div
        id="swagger-ui-root"
        className="flex-1"
        style={{ colorScheme: "light", background: "#fff" }}
      />
    </div>
  );
}
